import axios from 'axios'
import { getStorage } from 'utils/localstorage'
import Cookies from 'js-cookie'

const TIMEOUT = 1 * 60 * 1000
axios.defaults.timeout = TIMEOUT

axios.defaults.baseURL = `${process.env.REACT_APP_SERVER_HOST}/api/v1/crm/`

// 共通header
axios.defaults.headers.common = {}
axios.defaults.headers.common.accept = 'application/json'

// リクエストの共通処理
axios.interceptors.request.use((config) => {
  const accessToken = getStorage('access_token')
  config.headers.common['Access-Token'] = accessToken

  const ssoSessionKey = Cookies.get('common_sso_session_key')
  config.headers.common['Common-Sso-Session-Key'] = ssoSessionKey === undefined ? '' : window.btoa(ssoSessionKey)
  // APIを実行するたびに期限更新
  if (ssoSessionKey !== undefined) {
    Cookies.set('common_sso_session_key', ssoSessionKey, {
      expires: 1,
      ...(process.env.REACT_APP_ENV === 'local' ? {} : { domain: process.env.REACT_APP_SSO_COOKIE }),
    })
  }

  return config
})

// レスポンスの共通処理
// API仕様についての詳細は https://github.com/team-lab/spree_tlb_megane_backend/issues/378 を参照
// エラー時は呼び出し先のcatchでmessageを配列型で受け取れるようにする
axios.interceptors.response.use(
  (response) => {
    if (response.data.code && response.data.code === 401) {
      // APIキー無効の場合はログインにリダイレクト
      window.location = '/ninal/mypage/login?redirected=true'

      return Promise.reject(response.data.content ? response.data.content.message : ['error'])
    }

    // 400および500エラーはここで処理
    if (
      response.data.code &&
      (response.data.code === 400 || response.data.code === 401 || response.data.code === 500)
    ) {
      return Promise.reject(response.data.content ? response.data.content.message : ['error'])
    }

    return response
  },
  (error) => {
    // タイムアウトをはじめとるその他のエラーはここで処理
    return Promise.reject([error])
  }
)
